import { createTheme } from "@mui/material";

const baseTheme = createTheme({
  typography: {
    fontFamily: "'Inter', system-ui, sans-serif",

    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },

    h2: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },

    h3: {
      fontSize: "1.2rem",
      fontWeight: 600,
    },

    h4: {
      fontSize: "1.1rem",
    },

    body1: {
      fontSize: "1rem",
    },

    body2: {
      fontSize: "0.9rem",
    },

    subtitle1: {
      fontSize: "0.8rem",
    },

    subtitle2: {
      fontSize: "0.6rem",
    },

    menuItem: {
      fontSize: "0.8rem",
      fontWeight: 100,
    },

    sidebarTitle: {
      fontSize: "0.9rem",
      fontWeight: 600,
      textTransform: "uppercase",
    },
  },

  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          menuItem: "span",
          sidebarTitle: "span",
        },
      },
    },
  },
});

export default baseTheme;